/*
 * File: InputSwitch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for Switch input element
 */
import React from "react";
import { observer } from "mobx-react";
import UISwitch from "components/ui/UISwitch";
import PropTypes from "prop-types";

const InputSwitch = ({ field, value, switchOnChange }) => {
  return (
    <UISwitch
      switchOnChange={switchOnChange}
      name={field.name}
      id={field.id}
      value={value}
      disabled={field.disabled}
      formControlLabel={field.formControlLabel}
    />
  );
};

InputSwitch.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.node.isRequired,
  switchOnChange: PropTypes.func
};

export default observer(InputSwitch);
